import { STRIPE_SLICE } from "./slice";

export const LOAD_STRIPE_PRODUCTS_ACTION = `${STRIPE_SLICE}/loadStripeProducts` as const;